import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIRequestStatus } from 'common-ts/dist/models/APIRequestStatus';
import axios from 'axios';

interface WorkPointManualPostState {
  workPointManualList: any[],

  dialogOpen: boolean
  dialogOpenUpdate: boolean

  dialogExecutorInputOpen: boolean

  updateDraft: any

  status: APIRequestStatus
  error: string
}

const initialState: WorkPointManualPostState = {
    workPointManualList: [],

    dialogOpen: false,
    dialogOpenUpdate: false,

    dialogExecutorInputOpen: false,

    updateDraft: {},

    status: APIRequestStatus.Idle,
    error: ''
}

export const fetchWorkPointManualList = createAsyncThunk('workPointManual/fetchWorkPointManualList', async () => {
    const response = await axios({
        method: 'get',
        url: 'https://8mav2hp6ki.execute-api.ap-southeast-1.amazonaws.com/OrderAPIProduction/work-manual-point',
    });
    return response.data
})

const workPointManualPostSlice = createSlice({
    name: 'workPointManual',
    initialState,
    reducers: {
        updateDialogOpen(state, action) {
            state.dialogOpen = action.payload;
        },
        updateDialogOpenUpdate(state, action) {
            state.dialogOpenUpdate = action.payload;
        },
        updateDialogOpenExecutorInput(state, action) {
            state.dialogExecutorInputOpen = action.payload;
        },
        updateValUpdateDraft(state, action) {
            state.updateDraft = action.payload;
        }
    },
    extraReducers(builder) {
        builder
          .addCase(postNewWorkPointManual.pending, (state, action) => {
            state.status = APIRequestStatus.RequestInProgress;
          })
          .addCase(postNewWorkPointManual.fulfilled, (state, action) => {
            state.status = APIRequestStatus.Success;

            state.dialogOpen = false;
          })
          .addCase(postNewWorkPointManual.rejected, (state, action) => {
            state.status = APIRequestStatus.Failure;
            console.log("fetch is failure");
          })
          .addCase(postUpdateWorkPointManual.pending, (state, action) => {
            state.status = APIRequestStatus.RequestInProgress;
          })
          .addCase(postUpdateWorkPointManual.fulfilled, (state, action) => {
            state.status = APIRequestStatus.Success;

            state.dialogOpenUpdate = false;
          })
          .addCase(postUpdateWorkPointManual.rejected, (state, action) => {
            state.status = APIRequestStatus.Failure;
            console.log("fetch is failure");
          })
          .addCase(fetchWorkPointManualList.pending, (state, action) => {
          })
          .addCase(fetchWorkPointManualList.fulfilled, (state, action) => {
              state.workPointManualList = action.payload.recordList;
          })
          .addCase(fetchWorkPointManualList.rejected, (state, action) => {
          })
      }
})

export const postNewWorkPointManual = createAsyncThunk('workPointManual/postNewWorkPointManual', async (arg: any, thunkAPI) => {
    const state: any = thunkAPI.getState();

    const response = await axios({
      method: 'post',
      url: 'https://8mav2hp6ki.execute-api.ap-southeast-1.amazonaws.com/OrderAPIProduction/work-manual-point',
      data: arg
    });

    thunkAPI.dispatch(fetchWorkPointManualList());

    return response.data
})

export const postUpdateWorkPointManual = createAsyncThunk('workPointManual/postUpdateWorkPointManual', async (arg: any, thunkAPI) => {
    const state: any = thunkAPI.getState();

    const response = await axios({
      method: 'post',
      url: 'https://8mav2hp6ki.execute-api.ap-southeast-1.amazonaws.com/OrderAPIProduction/work-manual-point',
      data: {
        ...arg,
      }
    });

    thunkAPI.dispatch(fetchWorkPointManualList());

    return response.data
})

export const { updateDialogOpen, updateDialogOpenUpdate, updateDialogOpenExecutorInput, updateValUpdateDraft } = workPointManualPostSlice.actions

export default workPointManualPostSlice.reducer